import { SectionOne } from "../components/feature/profile";

export default function Profile()
{
    return(
        <section className="">
            <SectionOne/>
        </section>
    );
}